// useFetch hook
import useFetch from "../hook/useFetch";
// link
import { Link } from "react-router-dom";

export default function CartegoryNav() {
  const { data } = useFetch("/categories");

  return (
    <aside className="hidden xl:flex">
      <div className="card flex flex-col w-[286px] h-[500px] overflow-hidden">
        <div className="bg-brand py-4 text-white uppercase font-semibold flex items-center justify-center tracking-wide">
          Browse Categories
        </div>
        <div className="flex flex-col p-3">
          {data?.map((category) => {
            return (
              <Link
                to={`/products/${category.slug}`}
                className="group flex items-center gap-x-2 px-3 py-3 rounded-btn uppercase text-muted hover:text-ink hover:bg-surface transition-colors"
                key={category._id}>
                <span className="w-1.5 h-1.5 rounded-full bg-brand opacity-0 group-hover:opacity-100 transition-opacity" />
                {category.title}
              </Link>
            );
          })}
        </div>
      </div>
    </aside>
  );
}
